import { render } from "./DocumentLocationList.vue?vue&type=template&id=9c7c56a6&scoped=true"
import script from "./DocumentLocationList.vue?vue&type=script&lang=js"
export * from "./DocumentLocationList.vue?vue&type=script&lang=js"

import "./DocumentLocationList.vue?vue&type=style&index=0&id=9c7c56a6&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c7c56a6"]])

export default __exports__